<template>
  <layout :title="$t('moduleTitle')">
    <template v-slot:submenu>
      <!-- Primera seccion -->
      <v-container>
        <v-row>
          <v-toolbar flat color="fondo" height="30px" >
            <router-link router :to="option" v-for="(option, i) in options" :key="i">
              <div v-if="option.children !=null">
                <v-btn text small class="white--text">{{$t(option.name)}}</v-btn>
              </div> 
              </router-link>
          </v-toolbar>
        </v-row>
      </v-container>
    </template>
    <!-- Contenido -->
    <template v-slot:content>
      <v-data-table
        :headers="headers"
        :items="desserts"
        sort-by="calories"
        class="elevation-1 "
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="ma-2" outlined color="white" v-on="on">{{$t('tblbutton')}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.ubicacion" :label="$t('mdltext1')"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.descripcion" :label="$t('mdltext2')"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">{{$t('mdlCancel')}}</v-btn>
                  <v-btn color="blue darken-1" text @click="save">{{$t('mdlSave')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.true="{ item }">
          <v-col v-if="item.habilitada === true">
            <v-btn icon color="accent">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="cancel">
              <v-icon>mdi-thumb-down</v-icon>
            </v-btn>
          </v-col>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";

export default {
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    var options = [];
    this.$router.options.routes.forEach(route => {
      if (route.showInMenu) {
        options.push({
          to: route,
          icon: route.icon,
          name: route.name,
          children: route.children
        });
      }
    });
    return {
      options: options,
      dialog: false,
      headers: [
        {
          text: "Localidad",
          sortable: true,
          value: "ubicacion"
        },
        { text: "Descripcion", value: "descripcion" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      desserts: [
        {
          ubicacion: "Puebla",
          descripcion: "Parque Finsa"
        },
        {
          ubicacion: "Polanco",
          descripcion: "Mexico"
        },
        {
          ubicacion: "Monterrey",
          descripcion: "Area Desconocida"
        }
      ],
      editedIndex: -1,
      editedItem: {
        ubicacion: "",
        descripcion: ""
      },
      defaultItem: {
        ubicacion: "",
        descripcion: ""
      }
    };
  },
  mounted: () => {},
  computed: {
    locale() {
      return this.$store.getters["locale"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
    },
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>